import { Component, Input, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { PageTitleService } from '@marketing/page-title/page-title.service';
import { Labels, LabelCollection } from '@utils/labels';
import { Component as BrComponent } from '@bloomreach/spa-sdk/';
import { Page, Reference } from '@bloomreach/spa-sdk';

@Component({
  selector: 'ft-profile-tile',
  templateUrl: './profile-tile.component.html',
  styleUrls: ['./profile-tile.component.scss'],
})
export class ProfileTileComponent implements OnInit {
  @Input() profile!: any;
  @Input() component!: BrComponent;
  @Input() page!: Page;
  profileImage: string;

  constructor() {}

  /**
   * On init hook
   */
  ngOnInit() {
    if (!this.profile && this.component) {
      const profileRef = this.component.getModels<DocumentData>()?.document;
      const profileDoc: any = this.page.getContent(profileRef);
      if (profileDoc) {
        this.profile = profileDoc.model;
      }
    }

    if (this.profile && this.profile.profileImage) {
      this.profileImage = this.getImageVariantUrl(
        this.profile.profileImage.image,
        'pmHeadshotBioPage'
      );
    }
  }

  getImageVariantUrl(imageRef: Reference, variant: string): string {
    if (imageRef) {
      const image = this.page.getContent(imageRef)?.getData();
      if (image) {
        const imageVariant = image[variant];
        return imageVariant.links.site.href;
        // removed old code for pre 14.1 images as had dependency on old ng sdk
      }
    }
  }
}
